import React from 'react';

const ConfigAssistant = props => {
  const { message, driveToggle, list } = props;

  return (
    <div className="config-assistant">
      {message}
      {driveToggle}
      {list}
    </div>
  );
};

export default ConfigAssistant;
